"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _episourceColor = _interopRequireDefault(require("../../themes/episourceColor"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useStyles = (0, _styles.makeStyles)(() => (0, _styles.createStyles)({
  formControl: {
    margin: '0 8px'
  },
  inputLabel: {},
  iconButton: {},
  disabledButton: {},
  textField: {
    '& .MuiFilledInput-root': {
      background: _episourceColor["default"].textContrast
    }
  }
}));
const SearchBar = _ref => {
  let {
    label,
    value,
    onChange,
    onSearch,
    className,
    placeholder,
    autoFocus = true
  } = _ref;
  const classes = useStyles({});
  const [query, setQuery] = (0, _react.useState)(value || '');
  const onChangeHandler = event => {
    setQuery(event.target.value);
    if (typeof onChange !== 'undefined') {
      onChange(event.target.value);
    }
  };
  const onSearchHandler = () => {
    if (typeof onSearch !== 'undefined') {
      onSearch(query);
    }
  };
  const catchReturn = event => {
    if (event.key === 'Enter') {
      onSearchHandler();
    }
  };
  const formControlClassName = className ? "".concat(classes.formControl, " ").concat(className) : classes.formControl;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    variant: "filled",
    className: formControlClassName
  }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    className: classes.textField,
    autoFocus: autoFocus,
    id: "global-search",
    label: label || 'Search',
    type: "search",
    variant: "filled",
    defaultValue: value,
    onChange: onChangeHandler,
    onKeyPress: catchReturn,
    placeholder: placeholder,
    autoComplete: "off"
  })));
};
var _default = SearchBar;
exports["default"] = _default;